module.exports = __webpack_public_path__ + "img/Online-appointments.a4d62a6b.svg";